<template>
  <Result
    :icon="resultIcon"
    :title="resultTitle"
    :show-device-tag="true"
    :description="resultDescription"
    :btnText="resultBtnText"
    :error="true"
    @dismissFunc="resultDismissFunc"
    :custom-footer="true"
  >
    <div class="w-100 mt-auto mb-0">
      <Button id="wp-btn" class="text-center p-3 mb-3" @click="openWhatsApp()">
        <span class="text-center text-white fw-bold my-auto">
          {{ t("PAYJOY_CARD_VIEWS.RESULT_SHIPPING_FORM.WHATSAPP") }}
        </span>
      </Button>
      <Button class="text-center p-3" @click="resultDismissFunc()">
        <p class="text-center text-white fw-bold my-auto">
          {{ resultBtnText }}
        </p>
      </Button>
    </div>
  </Result>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import Result from "@/apps/credit-line/components/Result.vue";
import Button from "@/apps/credit-line/components/Button.vue";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import { useRouter } from "vue-router";
import useAsset from "@/apps/credit-line/helpers/useAsset";

// Create missing refs
const resultIcon = ref<string>("");
const resultTitle = ref<string>("");
const resultDescription = ref<string>("");
const resultBtnText = ref<string>("");

const { t } = useI18n();
const router = useRouter();

resultIcon.value = useAsset("img/credit-line/error_warning_icon.svg");
resultTitle.value = t("PAYJOY_CARD_VIEWS.KYC_VALIDATION_ERROR_TITLE");
resultDescription.value = t(
  "PAYJOY_CARD_VIEWS.KYC_VALIDATION_ERROR_DESCRIPTION"
);
resultBtnText.value = t("PAYJOY_CARD_VIEWS.KYC_VALIDATION_ERROR_BTN");

const resultDismissFunc = () => {
  router.replace({
    name: "CreditLineHelpView",
  });
  return;
};

const openWhatsApp = () => {
  const helpMsg = t("CL_WP_HELP_MSG", {
    deviceTag: AuthenticationHelper.getDeviceTag(),
  });
  window.open("https://wa.me/+525575028669?text=" + helpMsg, "_system");
};
</script>
